export const TimeOut = 60000;
export const AppInfo = {
    title: "Devextreme Vue3",
};
